// src/components/TeslimFormu.js

import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider, Grid } from '@mui/material';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

export const TeslimFormu = React.forwardRef(({ workOrder: serviceRecord }, ref) => {
    // Gelen prop'un adını içeride "serviceRecord" olarak kullanıyoruz
    if (!serviceRecord) { return <Box ref={ref}>Form verisi yükleniyor...</Box>; }

    const formatDate = (timestamp) => {
        return timestamp ? format(timestamp.toDate(), 'dd MMMM yyyy HH:mm', { locale: tr }) : '-';
    };

    return (
        <Box ref={ref} sx={{ p: 4, width: '210mm', minHeight: '297mm', margin: 'auto', boxSizing: 'border-box', color: '#000' }}>
            <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 4 }}>
                <Grid item>
                    <img src="/logo.png" alt="Medikal Patron Logo" style={{ maxHeight: '100px' }} />
                </Grid>
                <Grid item sx={{ textAlign: 'right' }}>
                    <Typography variant="h5" fontWeight="bold">SERVİS TESLİM FORMU</Typography>
                    <Typography variant="body2">Servis No: #{serviceRecord.id.substring(0, 8).toUpperCase()}</Typography>
                    <Typography variant="body2">Tarih: {formatDate(serviceRecord.olusturmaTarihi)}</Typography>
                </Grid>
            </Grid>

            <Divider sx={{ mb: 4 }} />

            <Grid container spacing={4} sx={{ mb: 4 }}>
                <Grid item xs={6}>
                    <Typography variant="h6" borderBottom={1} borderColor="grey.300" pb={0.5} mb={1}>Müşteri Bilgileri</Typography>
                    <Typography><strong>Ad Soyad:</strong> {serviceRecord.musteriAdSoyad}</Typography>
                    <Typography><strong>Telefon:</strong> {serviceRecord.musteriTelefon}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="h6" borderBottom={1} borderColor="grey.300" pb={0.5} mb={1}>Cihaz Bilgileri</Typography>
                    <Typography><strong>Seri Numarası:</strong> {serviceRecord.cihazSeriNumarasi}</Typography>
                    <Typography><strong>Marka/Model:</strong> {serviceRecord.cihazMarkaModel}</Typography>
                </Grid>
            </Grid>

            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" borderBottom={1} borderColor="grey.300" pb={0.5} mb={1}>Servis Detayları</Typography>
                <Typography><strong>Arıza Tanımı / Talep:</strong> {serviceRecord.arizaTanimi || '-'}</Typography>
                <Typography sx={{ mt: 1 }}><strong>Yapılan İşlemler:</strong> {serviceRecord.yapilanIslemler || '-'}</Typography>
            </Box>

            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" borderBottom={1} borderColor="grey.300" pb={0.5} mb={1}>Kullanılan Malzemeler ve Finansal Özet</Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Malzeme / Hizmet Açıklaması</TableCell>
                                <TableCell align="right">Tutar</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(serviceRecord.kullanilanParcalar || []).map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.aciklama}</TableCell>
                                    <TableCell align="right">{(item.fiyat || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow><TableCell colSpan={2} sx={{ border: 'none', p: 1 }} /></TableRow>
                             <TableRow sx={{ '& td': { borderTop: '1px solid #ddd !important', fontWeight: 'bold' } }}>
                                <TableCell>TOPLAM TUTAR</TableCell>
                                <TableCell align="right">{(serviceRecord.toplamTutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</TableCell>
                            </TableRow>
                             <TableRow sx={{ '& td': { border: 'none', fontWeight: 'bold' } }}>
                                <TableCell>ÖDENEN TUTAR</TableCell>
                                <TableCell align="right">{(serviceRecord.odenenTutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</TableCell>
                            </TableRow>
                             <TableRow sx={{ '& td': { border: 'none', fontWeight: 'bold', fontSize: '1.1rem' } }}>
                                <TableCell>KALAN BAKİYE</TableCell>
                                <TableCell align="right">{(serviceRecord.kalanTutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            <Box sx={{ position: 'absolute', bottom: 40, width: 'calc(210mm - 64px)' }}>
                <Divider sx={{ mb: 4 }} />
                <Grid container justifyContent="space-around">
                    <Grid item sx={{ textAlign: 'center' }}>
                        <Typography>Teslim Eden</Typography>
                        <Box sx={{ borderBottom: '1px solid black', width: 200, mt: 6 }}></Box>
                    </Grid>
                    <Grid item sx={{ textAlign: 'center' }}>
                        <Typography>Teslim Alan</Typography>
                        <Box sx={{ borderBottom: '1px solid black', width: 200, mt: 6 }}></Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
});